import { useSyncExternalStore } from 'react';
import {
  getAbsoluteTimeFormat,
  subscribeAbsoluteTimeFormat,
  type AbsoluteTimeFormat,
} from '@/lib/absoluteTimeFormat';

/**
 * The absolute timestamp format (Settings → Preferences → Timestamp Format).
 * Re-renders the caller when it changes, in this tab or another.
 */
export function useAbsoluteTimeFormat(): AbsoluteTimeFormat {
  return useSyncExternalStore(
    subscribeAbsoluteTimeFormat,
    getAbsoluteTimeFormat
  );
}
